import React from 'react';

function Banner() {
  return <div className="profile-page-bg-banner bg-primary d-none d-md-block p-relative" />;
}

export default Banner;
